module.exports = __webpack_public_path__ + "img/bg-type05.c6fc1c15.png";